import { Alert, Box, Stack, TextField, CircularProgress } from '@mui/material';
import axios from 'axios';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { EMAIL_REGEX } from '../../../utils/constants';
import SERVER_API_URL from '../../../config';
import { EMAIL_EXCEPTION } from '../../../utils/exception';
import CustomButton from '../../../components/custom-button/CustomButton';

export default function ForgetPassword() {
  const [error, setError] = useState();
  const [disabled, setDisabled] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(true);
    const data = new FormData(e.currentTarget);
    if (!EMAIL_REGEX.test(data.get('email'))) {
      setError(EMAIL_EXCEPTION);
      setDisabled(false);
    }

    try {
      const jsonData = Object.fromEntries(data.entries());
      const response = await axios.post(`${SERVER_API_URL}/auth/forgotPassword`, jsonData);
      if (response.status === 202) {
        setError(null);
        navigate('/getVerificationCode', { state: { email: jsonData.email } });
      }
    } catch (e) {
      setDisabled(false);
      if (e.code === 'ERR_NETWORK') {
        setError('የኔትወርክ ችግር አለ። እባክዎ ትንሽ ቆይተው ይሞክሩ!');
      } else if (e.response.status === 404) {
        setError('ከዚህ ኢሜይል አድራሻ ጋር የተገናኘ ተጠቃሚ የለም።');
      } else {
        setError('የአውታረ መረብ ስህተት! እባክዎን በኋላ ይሞክሩት!');
      }
    }
  };
  return (
    <Box component="form" onSubmit={handleSubmit}>
      <Stack spacing={3} sx={{ my: 2 }}>
        {error && (
          <Alert sx={{ width: '100%' }} severity="error">
            {error}
          </Alert>
        )}
        <TextField
          variant="outlined"
          id="email"
          name="email"
          label="ኢሜይል"
          autoComplete="ኢሜይል"
          autoFocus
          placeholder="ኢሜይል"
          required
        />
      </Stack>

      <CustomButton fullWidth size="large" type="submit" variant="contained" disabled={disabled}>
        {!disabled && <>አስገባ</>}
        {disabled && (
          <>
            <CircularProgress style={{ width: '20px', height: '20px' }} />  አስገባ...
          </>
        )}
      </CustomButton>

      <Stack direction="row" justifyContent="right" sx={{ mt: 2 }}>
        <Link
          to="/login"
          sx={{
            color: (theme) => theme.palette.primary.main,
            pt: 2,
            pb: 2,
            cursor: 'pointer',
            textDecoration: 'none',
            '&:hover': {
              textDecoration: 'underline',
            },
            padding: '20px',
          }}
        >
          ተመለስ
        </Link>
      </Stack>
    </Box>
  );
}
